import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/Login.vue'
import Home from '@/views/Home.vue'
import AccountManagement from '@/views/AccountManagement.vue'
import FieldControl from '@/views/FieldControl.vue'
import ViolationVerification from '@/views/ViolationVerification.vue'
import VoiceControl from '@/views/VoiceControl.vue'
import SystemSettings from '@/views/SystemSettings.vue'
import ProductExplanation from '@/views/ProductExplanation.vue'
import VoiceReply from '@/views/VoiceReply.vue'
import YellowCart from '@/views/YellowCart.vue'
import StickyOverlay from '@/views/StickyOverlay.vue'
import AudioPlayback from '@/views/AudioPlayback.vue'
import ImageFunction from '@/views/ImageFunction.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    name: 'Home',
    component: Home
  },

  {
    path: '/account',
    name: 'AccountManagement',
    component: AccountManagement
  },
  {
    path: '/product-explanation',
    name: 'ProductExplanation',
    component: ProductExplanation
  },
  {
    path: '/field-control',
    name: 'FieldControl',
    component: FieldControl
  },
  {
    path: '/violation',
    name: 'ViolationVerification',
    component: ViolationVerification
  },
  {
    path: '/sticky',
    name: 'StickyOverlay',
    component: StickyOverlay
  },
  {
    path: '/stats',
    name: 'VoiceControl',
    component: VoiceControl,

  },
  {
    path: '/voice-reply',
    name: 'VoiceReply',
    component: VoiceReply
  },
  {
    path: '/image-function',
    name: 'ImageFunction',
    component: ImageFunction
  },
  {
    path: '/audio-playback',
    name: 'AudioPlayback',
    component: AudioPlayback
  },
  {
    path: '/yellow-cart',
    name: 'YellowCart',
    component: YellowCart
  },
  {
    path: '/settings',
    name: 'SystemSettings',
    component: SystemSettings
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
